'use strict';

import React, {Component, PropTypes} from 'react';

import DropDownMenu from '../../../../common/components/c_DropDownMenu';
import ResetIcon from '../../../../common/svgs/ResetIcon';
import { assign, debounce, get, isEmpty, isEqual } from 'lodash';
import { employeeTypes } from '../../../../common/enums.js';

const dateOptions = [
  {id: 'past due', name: 'Past Due'},
  {id: 'today', name: 'Today'},
  {id: 'tomorrow', name: 'Tomorrow'},
  {id: 'this week', name: 'This Week'},
  {id: 'next week', name: 'Next Week'},
  {id: 'this month', name: 'This Month'},
  {id: 'future', name: 'Future'}
];

const appliedDateOptions = [
  {id: 'today', name: 'Today'},
  {id: 'yesterday', name: 'Yesterday'},
  {id: 'past week', name: 'Past Week'},
  {id: 'past month', name: 'Past Month'},
  {id: 'past year', name: 'Past Year'},
];

const availabilityDateOptions = [
  {id: 'past', name: 'Past'},
  {id: 'next 30 days', name: 'Next 30 Days'},
  {id: 'next 60 days', name: 'Next 60 Days'},
  {id: 'next 90 days', name: 'Next 90 Days'},
  {id: 'next 120 days', name: 'Next 120 Days'},
  {id: 'next 180 days', name: 'Next 180 Days'},
];

const initState = {
  statuses: null,
  followUpDate: null,
  appliedDate: null,
  timezone: null,
  bestContactTime: null,
  qs: null,
};

export default class Filters extends Component {
  static propTypes = {
    onFilterChange: PropTypes.func,
    staticData: PropTypes.object,
    specialists: PropTypes.array,
    terms: PropTypes.array,
    admin: PropTypes.bool,
    navColumnState: PropTypes.string.isRequired,
  }

  constructor(props, context) {
    super(props, context);

    let qualifyingSpecialists = [];
    if (!isEmpty(props.specialists)) {
      qualifyingSpecialists = props.specialists.map(item =>
        ({value:item.employeeId, primaryText:`${item.firstName} ${item.lastName}`})
      );
    }
    this.qsList = [...qualifyingSpecialists];

  }

  state = assign({}, initState);

  onChange(prop, event, value) {
    value = get(event, 'target.value', value);
    if (this.state[prop] !== value) {
      this.setState(assign(this.state, {
        [prop]: value
      }));
      debounce(this.props.onFilterChange, 200)(this.state);
    }
  }

  onDateChange(prop, event) {
    const value = event.target.value ? event.target.value.toString() : null;
    if (this.state[prop] !== value) {
      this.setState(assign(this.state, {
        [prop]: value
      }));
      debounce(this.props.onFilterChange, 200)(this.state);
    }
  }

  handleDropDownMenuUI(prop, items, label) {
    return {
      'data-id': prop,
      value: this.state[prop],
      menuItems: items,
      floatingLabelText: label,
      onChange: this.onChange.bind(this, prop),
      primaryText: 'All',
      includeDefault: true,
    };
  }

  reset() {
    this.setState(initState);
    debounce(this.props.onFilterChange, 200)(initState);
  }

  render() {

    const disabledStatusDropdown = (this.props.navColumnState === 'Standby');

    return (
      <div className='card-filters-container'>
        {
          this.props.admin
          &&
          <div className={'qs-filter-wapper'}>
          <DropDownMenu
            className={'qs-filter'}
            data-id={'Qualifying Specialist'}
            primaryText={'All QS'}
            includeDefault
            value={this.state.qs}
            menuItems={this.qsList}
            onChange={this.onChange.bind(this, 'qs')}
            />
            <ResetIcon onClick={() => this.reset()}/>
          </div>
        }

        <div className='center-column-1'>
          <DropDownMenu
            disabled={disabledStatusDropdown}
            className='status-dropdown'
            {...this.handleDropDownMenuUI('statuses', this.props.staticData.applicantStatus, 'Status')}
          />
          <DropDownMenu
            className='date-dropdown follow-up'
            {...this.handleDropDownMenuUI('followUpDate', dateOptions, 'Follow Up Date')}
          />
        </div>
        <div className='center-column-1'>
          <DropDownMenu
            className='date-dropdown applied'
            {...this.handleDropDownMenuUI('appliedDate', appliedDateOptions, 'Applied Date')}
          />
          <DropDownMenu
            className='date-dropdown availability'
            {...this.handleDropDownMenuUI('availabilityDate', availabilityDateOptions, 'Availability Date')}
          />
        </div>
        <div className='center-column-1'>
          <DropDownMenu
            className='timezone-dropdown'
            {...this.handleDropDownMenuUI('timezone', this.props.staticData.timezoneList, 'Time Zone')}
          />
          <DropDownMenu
            className='best-contact-time'
            {...this.handleDropDownMenuUI('bestContactTime', this.props.staticData.bestContactTimeList, 'Best Contact Time')}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/r_AdminDashboard/r_ApplicantManager/Filters/index.js